import { ArrowDownSolidV6, ArrowUpSolidV6 } from "@shared/v2/Icomoon";
import { Product } from "../../../../Support/Account/AddOnsSupport/types";

const InfoItem: React.FC<{ label: string; next?: "up" | "down"; value?: string | number }> = ({
  label,
  next,
  value,
}) => (
  <div className={`${next ? "tw-text-gray-50" : "tw-text-gray-30"} tw-flex tw-items-center tw-gap-[4px]`}>
    {next === "up" && <ArrowUpSolidV6 className="tw-text-semantic-green-120" />}
    {next === "down" && <ArrowDownSolidV6 className="tw-text-semantic-red-120" />}
    <b className={next ? "tw-font-bold tw-text-black" : ""}>{value}</b> {label}
  </div>
);

const UpDownProductInfo: React.FC<{ next?: "up" | "down"; product?: Product }> = ({ next, product }) => (
  <div className="tw-flex-1 tw-flex tw-flex-col tw-gap-[12px]">
    <div className="tw-flex tw-gap-[8px] tw-text-16d tw-font-semibold">
      <div className="tw-text-gray-50 tw-uppercase">{product?.tier}</div>
      {!next && <div className="tw-text-gray-30 tw-italic">Current Plan</div>}
    </div>
    <hr className="tw-p-0 tw-m-0 tw-border-gray-10" />
    {product?.details.trackingNumberMax && (
      <InfoItem next={next} label="Tracking Numbers" value={product.details.trackingNumberMax} />
    )}
    {product?.details.minutesPerMonth && (
      <InfoItem next={next} label="included minutes" value={product.details.minutesPerMonth} />
    )}
    {product?.details.overageMinutesPrice && (
      <InfoItem
        next={next}
        label={`per minute over ${product.details.minutesPerMonth?.toLocaleString()}`}
        value={`+${product.details.overageMinutesPrice * 100} cents`}
      />
    )}
  </div>
);

export default UpDownProductInfo;
